import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/app/rootReducer";
import { fetchWeekSummaryAction } from "../slices/weekSummarySlice";
import { FetchWeekSummaryRequest } from "@/api/fetchWeekSummary/types";

interface UseWeekSummaryOptions {
  yearNumbers: number[];
}

export function useWeekSummary(options: UseWeekSummaryOptions) {
  const dispatch = useDispatch();
  const { summaries, currentWeek, currentYear, loading, error } = useSelector(
    (state: RootState) => state.weekSummary,
  );

  const fetchSummaries = useCallback(() => {
    const requestData: FetchWeekSummaryRequest = {
      yearNumbers: options.yearNumbers,
      billingType: "metered",
    };
    dispatch(fetchWeekSummaryAction(requestData));
  }, [dispatch, options.yearNumbers]);

  useEffect(() => {
    fetchSummaries();
  }, [fetchSummaries]);

  const refresh = useCallback(() => {
    fetchSummaries();
  }, [fetchSummaries]);

  return {
    summaries,
    currentWeek,
    currentYear,
    loading,
    error,
    refresh,
  };
}
